import csv_svg from "../assets/csv.svg";
import pdf_svg from "../assets/pdf.svg";
import db_svg from "../assets/sql.svg";
import image_svg from "../assets/image.svg";
import chat_svg from "../assets/chatbot.svg";
import yt_svg from "../assets/youtube.svg";
import neo4j_svg from "../assets/neo4j.svg";
import collection_svg from "../assets/collection.svg";

import {
  COLLECTION,
  DATABASE,
  EXCEL,
  IMAGE,
  NEO4J,
  PDF,
  VANILLA,
  YOUTUBE,
} from "./constants";

const data: { [index: string]: any } = {
  default: {
    icon: chat_svg,
    displayName: VANILLA,
  },
  LLM: {
    icon: chat_svg,
    displayName: VANILLA,
  },
  rag: {
    icon: pdf_svg,
    displayName: PDF,
  },
  DOCS: {
    icon: pdf_svg,
    displayName: PDF,
  },
  image: {
    icon: image_svg,
    displayName: IMAGE,
  },
  excel: {
    icon: csv_svg,
    displayName: EXCEL,
  },
  sql: {
    icon: db_svg,
    displayName: DATABASE,
  },
  Database: {
    icon: db_svg,
    displayName: DATABASE,
  },
  database: {
    icon: db_svg,
    displayName: DATABASE,
  },
  DB: {
    icon: db_svg,
    displayName: DATABASE,
  },
  video: {
    icon: yt_svg,
    displayName: YOUTUBE,
  },
  YT: {
    icon: yt_svg,
    displayName: YOUTUBE,
  },
  neo4j: {
    icon: neo4j_svg,
    displayName: NEO4J,
  },
  collection: {
    icon: collection_svg,
    displayName: COLLECTION,
  },
  multiple: {
    icon: collection_svg,
    displayName: COLLECTION,
  },
};

export default data;
